import React, { Component } from 'react';

import { isAposFimInscricaoFimPagamento } from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';

import { patternEnum } from '../../variables/Enums/Enum';

import EnumService from '../../services/Enum';

import { numberFormat } from '../../helper/MaskHelper';

import { 
    ButtonNewTabCandidatosPorDepAdmin, 
    ButtonNewTabCandidatosPorDepAdminAndStatus
} from '../Buttons/ButtonsNewTab';

export class DadosDependenciasAdministrativas extends Component {
    constructor (props) {
        super(props);
        this.state = {
            optionsDepAdmin: [],
        }
    }

    sumCandidatosInscritos = () => this.props.dependencias.reduce((total, dep) => total + dep.candidatosInscritos, 0);
    sumCandidatosNaoFinalizados = () => this.props.dependencias.reduce((total, dep) => total + dep.candidatosNaoFinalizados, 0);
    sumCandidatosAguardandoPagamento = () => this.props.dependencias.reduce((total, dep) => total + dep.candidatosAguardandoPagamento, 0);
    sumCandidatosSemPendencias = () => this.props.dependencias.reduce((total, dep) => total + dep.candidatosComPendencias, 0);
    sumCandidatos = () => this.props.dependencias.reduce((total, dep) => total + dep.candidatos, 0);

    newTabCandidatosPorDepAdmin = (qtd, depAdmin, query = "") => <ButtonNewTabCandidatosPorDepAdmin qtd={numberFormat(qtd)} depAdmin={depAdmin} query={query} />
    newTabCandidatosPorDepAdminAndStatus = (qtd, depAdmin, status, query = "") => <ButtonNewTabCandidatosPorDepAdminAndStatus qtd={numberFormat(qtd)} depAdmin={depAdmin} status={status} query={query} />

    async componentDidMount() {
        const depsAdmin = await EnumService.listarDependenciasAdministrativas().then(res => res.data);
        this.setState({ optionsDepAdmin: [...depsAdmin], });
    }

    render () {
        const columns = [
            { label: 'Dependência Administrativa', name: 'dependenciaAdministrativa', func: (value, id) => patternEnum(value, this.state.optionsDepAdmin) , key: true, width: '25', orderLabel: 'asc', },
            { label: 'Candidatos', name: 'candidatos', func: (qtd, depAdmin) => this.newTabCandidatosPorDepAdmin(qtd, depAdmin), key: false, width: '15', },
            { label: 'Inscrições Finalizadas', name: 'candidatosInscritos', func: (qtd, depAdmin) => this.newTabCandidatosPorDepAdminAndStatus(qtd, depAdmin, "FINALIZADO"), key: false, width: '15', },
            { label: 'Inscrições Aguardando Pagamento', name: 'candidatosAguardandoPagamento', func: (qtd, depAdmin) => this.newTabCandidatosPorDepAdminAndStatus(qtd, depAdmin, "AGUARDANDO_PAGAMENTO"), key: false, width: '15', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Com Pendências', name: 'candidatosComPendencias', func: (qtd, depAdmin) => this.newTabCandidatosPorDepAdminAndStatus(qtd, depAdmin, "INICIADO"), key: false, width: '15', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Não Finalizadas', name: 'candidatosNaoFinalizados', func: (qtd, depAdmin) => this.newTabCandidatosPorDepAdminAndStatus(qtd, depAdmin, "INCOMPLETO", "&comEscolaSelecionada=true&comLocalProvaSelecionado=true"), key: false, width: '15', },
        ];
        
        const actions = [];

        const totals = [
            { column: 0, value: "Total", width: '25', },
            { column: 1, value: numberFormat(this.sumCandidatos()), width: '15', },
            { column: 2, value: numberFormat(this.sumCandidatosInscritos()), width: '15', },
            { column: 3, value: numberFormat(this.sumCandidatosAguardandoPagamento()), width: '15', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { column: 4, value: numberFormat(this.sumCandidatosSemPendencias()), width: '15', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { column: 5, value: numberFormat(this.sumCandidatosNaoFinalizados()), width: '15', },
        ]            

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.dependencias}
                        actions={actions}
                        page={null}
                        rowsPerPage={null}
                        sort={null}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosDependenciasAdministrativas;
